import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAccessRoutes, setAppData, setModuleRoutes, setRoleId } from "../redux/slices/authSlice";
import { useLazyFetchAccessModulesQuery } from "../redux/services/users";

const RouteFetcher = () => {
  const dispatch = useDispatch();

  const { isLoggedIn, accessRoutes } = useSelector((state) => state.auth);
  const [
    fetchRoutes,
    { data: routesData, isLoading: isLoadingRoutes, isSuccess },
  ] = useLazyFetchAccessModulesQuery();

  useEffect(() => {
    if (isLoggedIn && accessRoutes.length === 0) {
      fetchRoutes();
    }
  }, [isLoggedIn, accessRoutes.length, fetchRoutes]);

  useEffect(() => {
    if (routesData && !isLoadingRoutes) {
      dispatch(setAccessRoutes(routesData?.result));
      dispatch(setAppData(routesData?.response?.ui_access_routes));
      dispatch(setModuleRoutes(routesData?.response?.ui_access_routes || {}));
      dispatch(setRoleId(routesData?.response?.role_id));
    }
  }, [routesData, isLoadingRoutes, dispatch]);

  return null;
};

export default RouteFetcher;
